export default __webpack_public_path__ + "static/media/THE_MIRROR.ffc8f767.png";